import Link from 'next/link'

import { Image } from 'shared/ui'

import styles from './Copyright.module.scss'

export function Copyright() {
  return (
    <div className={styles.copyright}>
      <div className={styles.company}>
        <span className={styles.companyText}>
          Сайт разработан IT компанией{' '}
        </span>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href={'https://mdigital.kg/'}
        >
          <Image
            src={'/static/png/mdigital.png'}
            width={110}
            height={30}
            alt="mdigital"
          />
        </Link>
      </div>
      <span className={styles.copyrightText}>© 2025, Market.kg</span>
    </div>
  )
}
